import { render, staticRenderFns } from "./CreateSession.vue?vue&type=template&id=2a17259c&scoped=true"
import script from "./CreateSession.vue?vue&type=script&lang=js"
export * from "./CreateSession.vue?vue&type=script&lang=js"
import style0 from "./CreateSession.vue?vue&type=style&index=0&id=2a17259c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17259c",
  null
  
)

/* custom blocks */
import block0 from "./CreateSession.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports